import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const htmlDefinition: ComponentDefinition = {
  id: 'htmlExperience',
  name: 'HTML',
  category: 'Basic',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/code.svg',
  variables: {
    content: {
      displayName: 'Content',
      type: 'Text',
      defaultValue: '',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
  },
} as const;
